module.exports = __webpack_public_path__ + "static/phone.d3af8fb2.png";